import { render, staticRenderFns } from "./moduleAdd.vue?vue&type=template&id=0052be42&scoped=true"
import script from "./moduleAdd.vue?vue&type=script&lang=js"
export * from "./moduleAdd.vue?vue&type=script&lang=js"
import style0 from "./moduleAdd.vue?vue&type=style&index=0&id=0052be42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0052be42",
  null
  
)

export default component.exports